import { writePackageCartToCache } from "@/Apollo/hooks/package-cart/packageCartCache";
import { useDisplayCurrencyMutation } from "@/Apollo/hooks/useDisplayCurrencyMutation";
import mutationGQL from "@/Apollo/mutation/package-cart/removeFromPackageCart.graphql";
import {
  RemoveFromPackageCartMutation,
  RemoveFromPackageCartMutationVariables,
} from "@/Apollo/schema";
import { MutationHookOptions } from "@apollo/client";

export const useRemoveFromPackageCart = (
  options?: MutationHookOptions<
    RemoveFromPackageCartMutation,
    RemoveFromPackageCartMutationVariables
  >
) => {
  return useDisplayCurrencyMutation(mutationGQL, {
    ...options,
    update(cache, result, updateOptions) {
      writePackageCartToCache(
        cache,
        result.data?.removeFromPackageCart,
        updateOptions.variables?.displayCurrency ?? undefined
      );
      options?.update?.(cache, result, updateOptions);
    },
  });
};
